import React, { useContext, useState } from 'react';
import PropTypes from "prop-types";

import { get } from 'lodash';

const RuleSettingsContext = React.createContext();

const RuleSettingsProvider = (props) => {
  const [chartSize, setChartSize] = useState(get(props, 'chartSize'));
  const [chartType, setChartType] = useState(get(props, 'chartType'));
  const [mustContainRx, setMustContainRx] = useState(get(props, 'mustContainRx'));

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <RuleSettingsContext.Provider
      value={{
        chartSizeScales: props.chartSizeScales,
        chartSize,
        setChartSize,
        chartType,
        setChartType,
        mustContainRx,
        setMustContainRx,
        modalIsOpen,
        setModalIsOpen,
        handleRuleUpdate: props.handleRuleUpdate
      }}

      {...props}
    />
  );
};

export const useRuleSettings = () => {
  const context = useContext(RuleSettingsContext);

  if (context === undefined) {
    throw new Error("useRuleSettings must be used within a RuleSettingsProvider");
  }

  return context;
};

RuleSettingsProvider.prototype = {
  handleRuleUpdate: PropTypes.func,
  chartSize: PropTypes.number,
  chartType: PropTypes.string,
  mustContainRx: PropTypes.bool
};
export default RuleSettingsProvider;
